/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGrowRates} from '../api'

 export const useQueryGetGrowRates = createReactQueryHook('getGrowRates', getGrowRates)
